<div class="loading-indicator">
    <div class="loading-circle"></div>
</div>
